import React, { useMemo } from "react";
import { connect } from "react-redux";
import { IStore } from "reducers";
import { IState as Scope } from "reducers/scope";
import { format } from "lib/globalize-util";
import { ExportType } from "./types";
import { makeStyles } from "@material-ui/styles";
import theme from "styles/theme";
import { DATATEST } from "constants/integration";

interface IStateProps {
    scope?: Scope;
}

interface IProps {
    exportId?: string;
    exportType: ExportType;
}

function ExportInitiationResult({ exportId, exportType, scope }: IProps & IStateProps) {
    const classes = useStyles();

    const link = useMemo(() => {
        if (exportId) {
            let urlPath, text;
            switch (exportType) {
                case ExportType.Linesheet:
                    urlPath = `/brand/${scope.brand._id}/items/export/${exportId}`;
                    text = format("Click here to download your linesheet export");
                    break;
                case ExportType.OrderForm:
                    urlPath = `/brand/${scope.brand._id}/orders/export/${exportId}`;
                    text = format("Click here to download your order form export");
                    break;
                case ExportType.AtsReport:
                    urlPath = `/brand/${scope.brand._id}/ats/export/${exportId}`;
                    text = format("Click here to download your ATS report");
                    break;
                case ExportType.Items:
                    urlPath = `/brand/${scope.brand._id}/items/export/${exportId}`;
                    text = format("Click here to download your product export");
                    break;
            }
            return { urlPath, text };
        }
    }, [exportId, exportType, scope.brand._id]);

    return exportId ? (
        <div>
            <a data-test={DATATEST.EXPORT_TEMPLATES.EXPORT_DOWNLOAD_LINK} href={link.urlPath} target="_blank">
                {link.text}
            </a>
            <aside>{format("(This will open in a new tab).")}</aside>
        </div>
    ) : (
        <div className={classes.exportFailure}>
            {format("There was an error creating this export. Please refresh and try again.")}
        </div>
    );
}

const useStyles = makeStyles({
    exportFailure: {
        backgroundColor: theme.palette.warning,
        border: `1px solid ${theme.palette.error}`,
        padding: "6px",
    },
});

const mapStateToProps = (state: IStore): IStateProps => ({
    scope: state.scope,
});

export default connect<IStateProps, unknown, IProps>(mapStateToProps)(ExportInitiationResult);
